export default class OffCanvas {
	constructor(root, openBtn) {
		this.root = root;
		this.id = root?.getAttribute('id');
		this.closeBtns = root?.querySelectorAll(`.off-canvas-toggle[data-target="${this.id}"], .off-canvas-close`);
		openBtn?.addEventListener('click', this.open.bind(this));

		this.closeBtns?.forEach((btn) => {
			btn.addEventListener('click', this.close.bind(this));
		});
	}

	onOpen(callback = () => {}) {
		callback();
	}

	onClose(callback = () => {}) {
		callback();
	}

	open() {
		this.root?.classList.add('active');
		this.onOpen();
	}

	close() {
		this.root?.classList.remove('active');
		this.onClose();
	}
}
